/** page size for mail query  */
export const MAIL_QUERY_PAGE_SIZE = 25;

/** page size for people query */
export const PEOPLE_QUERY_PAGE_SIZE = 25;

/** Timezone */
export const UTC_TIMEZONE = 'UTC';
